import client from './index'
import { ApiResponse } from '@/models/api'

export interface GolfAreaPoint {
  lat: number
  lng: number
}

export interface GolfArea {
  id: string
  name: string
  type: 'parking' | 'alert'
  points: GolfAreaPoint[]
  is_active: boolean
  created_at?: string
  updated_at?: string
}

export interface CreateGolfAreaDto {
  name: string
  type: 'parking' | 'alert'
  points: GolfAreaPoint[]
  is_active: boolean
}

export interface UpdateGolfAreaDto {
  name?: string
  type?: 'parking' | 'alert'
  points?: GolfAreaPoint[]
  is_active?: boolean
}

export const getGolfAreas = () => {
  return client.get<ApiResponse<{ data: GolfArea[] }>>('/golf/areas')
}

export const createGolfArea = (data: CreateGolfAreaDto) => {
  return client.post<ApiResponse<GolfArea>>('/golf/areas', data)
}

export const updateGolfArea = (id: string, data: UpdateGolfAreaDto) => {
  return client.put<ApiResponse<GolfArea>>(`/golf/areas/${id}`, data)
}

export const deleteGolfArea = (id: string) => {
  return client.delete<ApiResponse<void>>(`/golf/areas/${id}`)
}
